import React from 'react';

interface RecycleIconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
}

const RecycleIcon: React.FC<RecycleIconProps> = ({
  fillColor = '#AAAAAA',
  ...rest
}) => {
  return (
    <svg
      {...rest}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Combined Shape"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.52306e-06 8.06621C-0.000250046 8.177 0.0184594 8.28794 0.0563077 8.39293L0.0604583 8.40421C0.184007 8.733 0.483497 8.96497 0.833336 8.96497H5.83334C6.29357 8.96497 6.66667 8.5635 6.66667 8.06825C6.66667 7.57301 6.29357 7.17154 5.83334 7.17154H2.93713L5.27065 4.81206C6.9076 3.05035 9.24325 2.32337 11.4759 2.86695C13.7085 3.41053 15.5258 5.14863 16.2894 7.47068C16.4429 7.93755 16.9191 8.1821 17.353 8.01688C17.7869 7.85167 18.0141 7.33927 17.8606 6.8724C16.9061 3.96984 14.6344 1.79721 11.8437 1.11774C9.05291 0.438266 6.13334 1.34698 4.1106 3.52466L1.66667 5.99539V2.68796C1.66667 2.19272 1.29357 1.79125 0.833336 1.79125C0.373098 1.79125 2.52306e-06 2.19272 2.52306e-06 2.68796V8.06621ZM19.1667 13.4525C19.1669 13.3418 19.1482 13.2308 19.1104 13.1258L19.1062 13.1145C18.9827 12.7857 18.6832 12.5538 18.3333 12.5538H13.3333C12.8731 12.5538 12.5 12.9553 12.5 13.4505C12.5 13.9457 12.8731 14.3472 13.3333 14.3472H16.2295L13.896 16.7067C12.2591 18.4684 9.92342 19.1954 7.69081 18.6518C5.4582 18.1082 3.64088 16.3701 2.87726 14.0481C2.72373 13.5812 2.24754 13.3367 1.81367 13.5019C1.3798 13.6671 1.15254 14.1795 1.30607 14.6464C2.26059 17.5489 4.53224 19.7215 7.323 20.401C10.1138 21.0805 13.0333 20.1718 15.0561 17.9941L17.5 15.5234V18.8308C17.5 19.326 17.8731 19.7275 18.3333 19.7275C18.7936 19.7275 19.1667 19.326 19.1667 18.8308V13.4525Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default RecycleIcon;
